
//#region English translation
export const TRANSLATE_ENGLISH = {
    "bee-common-top-bar": {
        "actions": "Actions",
        "help": "Help",
        "hide-structure": "Hide structure",
        "preview": "Preview",
        "save": "SAVE",
        "save-as-template": "Save as template",
        "send-test": "Send test",
        "settings": "Settings",
        "show-json-model": "Show JSON model",
        "show-structure": "Show structure",
        "hide-comments": "Hide comments",
        "show-comments": "Show comments"
    },
    "bee-common-widget-bar": {
        "body": "Settings",
        "column-properties": "Column properties",
        "content": "Content",
        "content-properties": "Content properties",
        "default-rows": "Default",
        "delete": "Delete",
        "duplicate": "Duplicate",
        "empty-rows": "Empty",
        "row-alt": "I'm an image",
        "row-bkg-over-txt": "Text on background pattern",
        "row-bullet-point": "Bullet point",
        "row-galleries-1": "Image gallery - Full width thumbnail",
        "row-galleries-2": "Image gallery - Two columns",
        "row-galleries-3": "Image gallery - Three columns",
        "row-galleries-4": "Image gallery - Four columns",
        "row-hero-bkg-over-txt": "Hero Image",
        "row-icon-1": "Main feature",
        "row-icon-2": "Features - Two columns",
        "row-icon-2-left": "Features - Two columns",
        "row-icon-3": "Features - Three columns",
        "row-icon-4": "Features - Four columns",
        "row-image-text-1": "Main article",
        "row-image-text-2": "Articles - Two columns",
        "row-image-text-2-h-left": "Article - Left aligned image",
        "row-image-text-2-h-right": "Article - Right aligned image",
        "row-image-text-3": "Articles - Three columns",
        "row-image-text-4": "Articles - Four columns",
        "row-lg-image-text-left": "Article - Left aligned XL image",
        "row-lg-image-text-right": "Article - Right aligned XL image",
        "row-paragraph": "Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean.",
        "row-properties": "Row properties",
        "row-sq-image-text-left": "Article - Square image - Left aligned",
        "row-sq-image-text-right": "Article - Square image - Right aligned",
        "row-text": "Behind the word mountains, far from the countries Vokalia and Consonantia.",
        "row-title-": " ",
        "row-title-article": "IT IS A PARADISEMANTIC COUNTRY",
        "row-title-bullet-point": "On her way she met a copy.",
        "row-title-drag-drop": "LINE LANEP",
        "row-title-feature": "BOOKMARKSGROVE",
        "row-title-here": "FAR FAR AWAY",
        "row-title-hero": "THERE LIVE THE BLIND TEXTS",
        "row-title-main": "RIGHT AT THE COAST OF THE SEMANTICS",
        "row-title-secure": "LINE LANE",
        "row-title-subtitle": "FAR FAR AWAY",
        "row-title-super-fast": "LINE LANE",
        "row-title-top-quality": "LINE LANE",
        "structure": "Rows",
        "validation-url-empty": "The Url is empty.",
        "validation-url-error": "The Url cannot be loaded.",
        "validation-url-https": "Urls must be https.",
        "validation-url-label": "Invalid Url",
        "empty-state": "No rows were found.",
        "save": "Save",
        "comments": "Show comments",
        "add-new-column": "Add new",
        "delete-column": "Delete",
        "column-add": "Column Added",
        "column-resize": "Column Width Changed",
        "column-delete": "Column Deleted",
        "columns-customize": "Customize Columns"
    },
    "bee-common-widgets-lock": {
        "label-locked": "Locked",
        "label-unlocked": "Unlocked"
    },
    "bee-controller": {
        "error-loading-template": "Oops! Something went wrong while loading your message.",
        "error-loading-template-title": "Error",
        "warning-loading-template": "Your message was loaded in compatibility mode. Some features may not be available.",
        "warning-loading-template-title": "Attention",
        "error-browser-title": "Your browser is not supported",
        "error-browser": "We detected an outdated browser (${browserName} ${browserVersion}) that is no longer supported.",
        "error-browser-details": "This application works best on Chrome, Firefox, Edge and Safari."
    },
    "bee-newsletter-modules-html": {
        "html": "<div class=\"our-class\"> I'm a new HTML block. </div>",
        "widget-warning-desc": "Using your own code may affect how the message is rendered. Make sure to use correct and responsive HTML.",
        "widget-warning-title": "HTML experts only"
    },
    "column-property-titles": {
        "1": "Column 1",
        "2": "Column 2",
        "3": "Column 3",
        "4": "Column 4",
        "5": "Column 5",
        "6": "Column 6",
        "7": "Column 7",
        "8": "Column 8",
        "9": "Column 9",
        "10": "Column 10",
        "11": "Column 11",
        "12": "Column 12",
        "four-columns-empty": "Four columns",
        "Four-columns-images": "Wide image group",
        "one-column-button": "Action button",
        "one-column-empty": "One column",
        "one-column-image": "Hero image",
        "one-column-text": "Wide text",
        "three-columns-empty": "Three columns",
        "three-columns-images": "Image group",
        "two-columns-4-8-empty": "Sidebar left",
        "two-columns-8-4-empty": "Sidebar right",
        "two-columns-empty": "Two columns",
        "two-columns-image-text": "Icon & text",
        "two-columns-text": "Double text"
    },
    "mailup-bee-app": {
        "prevent-close-confirm": "Leaving this page your changes will be lost! Do you really want to leave this page?"
    },
    "mailup-bee-common-widgets-align": {
        "label": "Align"
    },
    "mailup-bee-common-widgets-alt": {
        "label": "Alternate text"
    },
    "mailup-bee-common-widgets-background-color": {
        "label": "Background color"
    },
    "mailup-bee-common-widgets-background-color-column": {
        "label": "Column background"
    },
    "mailup-bee-common-widgets-background-color-content": {
        "label": "Content background color"
    },
    "mailup-bee-common-widgets-background-color-row": {
        "label": "Row background color"
    },
    "mailup-bee-common-widgets-background-image": {
        "center": "Center",
        "change-image": "Change image",
        "description": "Note that background images are not compatible with all email programs. When not supported, the row background color will be used instead. So make sure that color works well with your content.",
        "disabled": "Disabled",
        "edit": "Apply effects & more",
        "enabled": "Enabled",
        "fullwidth": "Full width",
        "label": "Row background image",
        "name": "Image name",
        "repeat": "Repeat",
        "url": "Url"
    },
    "mailup-bee-common-widgets-border": {
        "all-sides": "All sides",
        "bottom": "Bottom",
        "label": "Border",
        "left": "Left",
        "more-options": "More options",
        "right": "Right",
        "top": "Top"
    },
    "mailup-bee-common-widgets-border-radius": {
        "label": "Border radius"
    },
    "mailup-bee-common-widgets-button-link-type": {
        "label": "Link type"
    },
    "mailup-bee-common-widgets-button-width": {
        "label": "Auto width"
    },
    "mailup-bee-common-widgets-color": {
        "label": "Text color"
    },
    "mailup-bee-common-widgets-divider-mode": {
        "align": "Align",
        "height": "Height",
        "label": "Transparent",
        "line": "Line",
        "width": "Width"
    },
    "mailup-bee-common-widgets-dynamic-image": {
        "description": "When 'Dynamic image' is enabled, 'Url' becomes the location of a sample image shown in the editor. 'Dynamic Url' will be used in the HTML code. The size of the dynamic image will be set based on the sample one, so use a sample image of the same size.",
        "disabled": "Disabled",
        "enabled": "Enabled",
        "label": "Dynamic image",
        "src": "Dynamic Url"
    },
    "mailup-bee-common-widgets-font": {
        "body-label": "Default font",
        "label": "Font family"
    },
    "mailup-bee-common-widgets-hide-on-mobile": {
        "label": "Hide on mobile"
    },
    "mailup-bee-common-widgets-icons": {
        "configure-icon-collection": "Configure icon collection",
        "select-icon-collection": "Select icon collection"
    },
    "mailup-bee-common-widgets-icons-align-and-space": {
        "align": "Align",
        "icon-spacing": "Icon spacing"
    },
    "mailup-bee-common-widgets-image-align": {
        "align": "Align",
        "autowidth": "Auto width",
        "fullwidth": "Adjust to width",
        "fullwidth-blocked": "This image is bigger than the container, so it is automatically set to 'Adjust to width'.",
        "fullwidthOnMobile": "Full width on mobile",
        "label": "Align",
        "pixels-tooltip-label": "px",
        "switch-off-automatic": "Switch off 'Automatic image resizing' to manually resize the image."
    },
    "mailup-bee-common-widgets-image-editor": {
        "label": "Apply effects & more"
    },
    "mailup-bee-common-widgets-image-href": {
        "label": "Image link"
    },
    "mailup-bee-common-widgets-image-selector": {
        "edit": "Apply effects & more",
        "label": "Change image",
        "name": "Image name",
        "url": "Url"
    },
    "mailup-bee-common-widgets-line-height": {
        "label": "Line height"
    },
    "mailup-bee-common-widgets-link-color": {
        "label": "Link color"
    },
    "mailup-bee-common-widgets-message-background-color": {
        "label": "Content area background color"
    },
    "mailup-bee-common-widgets-message-width": {
        "label": "Content area width"
    },
    "mailup-bee-common-widgets-padding": {
        "all-sides": "All sides",
        "bottom": "Bottom",
        "label": "Padding",
        "left": "Left",
        "more-options": "More options",
        "right": "Right",
        "top": "Top"
    },
    "mailup-bee-common-widgets-padding-content": {
        "label": "Content padding"
    },
    "mailup-bee-common-widgets-row-display-condition": {
        "add": "Add condition",
        "after": "After",
        "before": "Before",
        "change": "Change condition",
        "delete": "Remove from row",
        "delete-confirmation-description": "In order to remove the condition from this specific row - exit this popup and click \"Remove from row\" on the sidebar.",
        "delete-confirmation-no": "No, keep it",
        "delete-confirmation-title": "Do you really want to remove this display condition from this row?",
        "delete-confirmation-yes": "Yes, remove it",
        "description": "Description",
        "edit": "Edit condition",
        "label": "Display condition",
        "name": "Name",
        "no-condition": "No display condition applied to this row",
        "remove": "Remove from row",
        "select": "Select condition"
    },
    "mailup-bee-common-widgets-row-display-flow-row": {
        "label": "Do not stack on mobile"
    },
    "mailup-bee-common-widgets-text-align": {
        "label": "Align"
    },
    "mailup-bee-common-widgets-video-content": {
        "arrow": "Arrow Only",
        "dark": "Dark",
        "description": "Add a <a href=\"https://www.youtube.com\" target=\"_blank\">YouTube</a> or <a href=\"https://vimeo.com\" target=\"_blank\">Vimeo</a> URL to automatically generate a preview image. The image will link to the provided URL.",
        "full": "Solid",
        "icon-color": "Play icon color",
        "icon-preview": "Play icon preview",
        "icon-size": "Play icon size",
        "icon-type": "Play icon type",
        "label": "Video url",
        "light": "Light",
        "outline": "Outline",
        "rectangle": "Rectangle",
        "round": "Round",
        "square": "Square",
        "embedded": "Embedded",
        "thumbnail": "Thumbnail",
        "custom": "Hosted video",
        "autoplay": "Autoplay",
        "controls": "Controls",
        "loop": "Loop"
    },
    "mailup-bee-common-widgets-width": {
        "label": "Width"
    },
    "mailup-bee-newsletter-modules-button": {
        "label": "<p style='font-family: inherit; font-size: 16px;'>Button</p>",
        "name": "Button"
    },
    "mailup-bee-newsletter-modules-divider": {
        "name": "Divider"
    },
    "mailup-bee-newsletter-modules-empty": {
        "label": "No content here. Drag new from 'Content' panel.",
        "name": "Empty"
    },
    "mailup-bee-newsletter-modules-html": {
        "name": "HTML"
    },
    "mailup-bee-newsletter-modules-image": {
        "browse": "Browse",
        "drop-here": "Drop your file here",
        "name": "Image"
    },
    "mailup-bee-newsletter-modules-merge-content": {
        "name": "Dynamic content"
    },
    "mailup-bee-newsletter-modules-social": {
        "name": "Social"
    },
    "mailup-bee-newsletter-modules-text": {
        "html": "<p style='font-size: 14px;'>I&apos;m a new Text block ready for your content.</p>",
        "name": "Text"
    },
    "mailup-bee-newsletter-modules-video": {
        "description": "Video",
        "label": "Add a video url",
        "name": "Video"
    },
    "mailup-bee-newsletter-stage": {
        "cancel": "Cancel",
        "delete": "Delete",
        "delete-configrmation-message": "This action cannot be undone.",
        "delete-configrmation-title": "Are you sure you want to delete this?",
        "delete-module-in-locked-row-error-message": "This row is locked and therefore its content cannot be edited.",
        "delete-module-in-locked-row-error-title": "This content block cannot be deleted",
        "delete-row-locked-content-error-message": "This row contains locked content and therefore cannot be deleted.",
        "delete-row-locked-content-error-title": "This row cannot be deleted",
        "drag-it-here": "Drag it here",
        "duplicate-module-in-locked-row-error-message": "This row is locked and therefore its content cannot be duplicated.",
        "duplicate-module-in-locked-row-error-title": "This content block cannot be duplicated",
        "duplicate-row-locked-content-error-message": "This row contains locked content and therefore cannot be duplicated.",
        "duplicate-row-locked-content-error-title": "This row cannot be duplicated",
        "locked-module-warning-message": "Locked content blocks cannot be edited.",
        "locked-module-warning-title": "This content is locked",
        "locked-row-warning-message": "This row is locked and therefore its content cannot be edited.",
        "locked-row-warning-title": "This row is locked",
        "delete-column-confirmation-message": "All the modules in this column will also be deleted.<br>This action cannot be undone."
    },
    "mailup-common-file-manager": {
        "action-delete": "Delete",
        "action-insert": "Insert",
        "action-preview": "Preview",
        "add-folder": "Add folder",
        "add-new-file": "Upload",
        "cancel": "Cancel",
        "close": "Close",
        "delete": "Delete",
        "delete-confirm-message": "This action cannot be undone.",
        "delete-confirm-title": "Are you sure you want to delete this file?",
        "delete-folder-button": "Close",
        "delete-folder-text": "Before deleting it you must delete or move its content",
        "delete-folder-title": "This folder is not empty",
        "drag-to-upload": "Drag your files here",
        "empty-folder": "Empty Folder, upload some files here.",
        "error-1055": "Your username is already in use. This may happen if the application is opened in multiple browser windows, or you are using a shared account.",
        "error-1055-title": "Authentication error",
        "error-3001": "Please try again.",
        "error-3001-title": "Oops! Something went wrong.",
        "error-3100": "Something went wrong while accessing the backend filesystem.",
        "error-3100-title": "Oops! Something went wrong.",
        "error-3200": "File or directory not found.",
        "error-3200-title": "Resource not found.",
        "error-3300": "Permission denied to access a file or a directory.",
        "error-3300-title": "Permission denied.",
        "error-3400": "File or directory already exists.",
        "error-3400-title": "Resource already exists.",
        "error-3450": "Error during file upload.",
        "error-3450-title": "File not uploaded.",
        "error-3500": "Server could not understand the request due to invalid syntax.",
        "error-3500-title": "Request error.",
        "error-3600": "Not a valid S3 custom storage.",
        "error-3600-title": "Oops! Something went wrong.",
        "error-3650": "Wrong Username or Password.",
        "error-3650-title": "Unauthorized.",
        "error-400": "Please try again.",
        "error-400-title": "Oops! Something went wrong.",
        "error-403": "You don't have permission to access this file or a directory.",
        "error-403-title": "Oops! Something went wrong.",
        "error-404": "The file or directory was not found.",
        "error-404-title": "Oops! Something went wrong.",
        "error-409": "The file or directory already exists.",
        "error-409-title": "Oops! Something went wrong.",
        "error-503": "Please try again.",
        "error-503-title": "Oops! Something went wrong.",
        "error-generic": "Oops! Something went wrong.",
        "error-generic-title": "Error",
        "error-uploading": "Oops! Something went wrong while uploading the image.",
        "error-uploading-title": "Upload error",
        "grid-view": "Grid view",
        "import-file": "Import",
        "list-view": "List view",
        "load-more": "Load more",
        "multi-delete-confirm-title": "Are you sure that you want delete this {{multiDeleteItems}} files?",
        "multiselect-actions": "Actions",
        "multiselect-delete-all": "Delete all",
        "multiselect-move-all": "Move all",
        "new-folder-placeholder": "Folder name",
        "overwrite": "Overwrite",
        "overwrite-confirm-message": "A previously uploaded file with the same name will be overwritten. This action cannot be undone.",
        "overwrite-confirm-title": "Are you sure you want to overwrite this file?",
        "read-only": "read only",
        "read-only-tooltip": "This label indicates that you can't modify the content of this folder. Please browse to another folder and try again.",
        "root-folder": "Home",
        "search-free-photos": "Search free photos",
        "search-noresults-text": "Try with a different term or change folder",
        "search-noresults-title": "No results found for",
        "search-not-found": "No result found",
        "search-not-found-message": "Try with something else.",
        "search-placeholder": "Search in folder",
        "select-all": "Select all",
        "select-file": "Select your file",
        "sort-date": "Date",
        "sort-name": "Name",
        "sort-size": "Size",
        "sort-type": "Type",
        "stats": "Showing {{visibleItems}} items of {{totalItems}}",
        "stock-images-creative-commons": "All images are published under the <strong>Creative Commons Zero</strong> license",
        "stock-images-description": "Find free high-quality images for your campaigns from <strong>more than 500,000 stock photos.</strong>",
        "stock-images-import": "Import",
        "stock-images-no-result-description": "Please, check the spelling or try more unspecific terms.",
        "stock-images-no-result-title": "Sorry, we couldn't find images that match your search",
        "stock-images-popular-images": "Popular images",
        "stock-images-powered-by": "Powered by",
        "stock-images-random-images": "Random images",
        "stock-images-search-alternatives": "or search...",
        "stock-images-search-for": "Results for",
        "stock-images-search-placeholder": "Search images",
        "stock-images-status": "{{pageCount}} of {{totalCount}} images",
        "stock-images-title": "Search free photos",
        "title": "File manager",
        "type-directory": "Folder",
        "type-document": "Document",
        "type-image": "Image",
        "upload-completed": "Upload completed",
        "upload-inprogress": "Upload in progress",
        "upload-status-current": "Completed {{items}} of {{totalItems}} uploads.",
        "upload-status-error": "{{items}} of {{totalItems}} files could not be uploaded.",
        "upload-status-queued": "Image queued",
        "upload-wait": "Almost done...",
        "validation-name-is-required": "is required",
        "validation-name-maximum": "must be shorter than %{count} characters",
        "validation-name-minium": "must be larger than %{count} characters",
        "validation-name-special-characters": "contains invalid characters (< > : \" / \\\\ | ? * characters are not permitted)",
        "warning-cant-create-folder-body": "The label {{readOnly}} indicates that you can't modify the content of this folder. Please browse to another folder and try again.",
        "warning-cant-create-folder-title": "Warning! You can’t create any folder inside this folder.",
        "warning-cant-upload-body": "The label {{readOnly}} indicates that you can't modify the content of this folder. Please browse to another folder and try again.",
        "warning-cant-upload-title": "Warning! You can’t upload any files to this folder.",
        "warning-delete-files": "It is not possible to delete this",
        "warning-delete-folder": "Only empty folders can be deleted",
        "warning-edit": "This content cannot be edited",
        "warning-unsupported-file-extension": "Oops, there’s a problem uploading your file.\nThe file format is not supported.",
        "error-3903-title": "Invalid characters",
        "error-3903": "The name contains invalid characters",
        "error-3410-title": "File not uploaded.",
        "error-3410": "File exceeds the maximum allowed size.",
        "error-3420-title": "File Not Uploaded.",
        "error-3420": "Filename extension is mandatory.",
        "error-3430": "Filetype Not Allowed.",
        "error-3430-title": "File Not Uploaded."
    },
    "mailup-common-font-selector": {
        "page-font": "Default font"
    },
    "mailup-common-href": {
        "link-file": "Link file",
        "link-sms": "Tel",
        "link-telephone": "Tel",
        "link-url": "Url",
        "special-link": "Special links",
        "anchor": "Scroll to"
    },
    "mailup-common-icons-organizer": {
        "add-new-icon": "Add new icon",
        "alt": "Alternate text",
        "close": "Close",
        "close-panel": "Close panel",
        "edit": "Edit",
        "follow": "Social follow",
        "link-placeholder": "complete or insert the url",
        "more-options": "More options",
        "others": "Other icons",
        "remove": "remove",
        "share": "Social share",
        "title": "כותרת",
        "url": "Url",
        "resize": "Resize & more",
        "custom": "Custom",
        "change": "Change icon",
        "add-custom": "Add a custom icon",
        "image-url": "Image url",
        "text": "Icon text",
        "text-position": "Text position",
        "target": "Target",
        "target-blank": "New page",
        "target-self": "Current page",
        "top": "Top",
        "right": "Right",
        "bottom": "Bottom",
        "left": "Left"
    },
    "mailup-common-language-selector": {
        "de-DE": "Deutsch",
        "en-US": "English",
        "es-ES": "Español",
        "fr-FR": "Français",
        "it-IT": "Italiano",
        "tr-TR": "Türkçe",
        "zh-CN": "中文"
    },
    "mailup-common-link-type-selector": {
        "body": "Body",
        "email-address": "Send email",
        "link-type": "Link type",
        "mail-to": "Mail to",
        "maps": "Show map",
        "subject": "Subject",
        "telephone": "Make call",
        "text": "Send SMS",
        "web-address": "Open web page",
        "anchor": "Internal link"
    },
    "mailup-common-page-preview": {
        "desktop": "Desktop",
        "disclaimer-description": "Consistently displaying an email across devices is a challenge. Responsive design provides a solution. This message will display properly in many mobile clients. The desktop version will be used when responsive design is not supported.",
        "disclaimer-title": "How will it look?",
        "error": "Oops! Something went wrong with the preview.",
        "error-title": "Preview error",
        "mobile": "Mobile",
        "preview-mode": "Preview mode"
    },
    "mailup-common-patch-provider": {
        "action-00": "dropped",
        "action-01": "dragged",
        "action-02": "deleted",
        "action-03": "duplicated",
        "action-04": "changed",
        "action-05": "opened",
        "action-06": "closed",
        "action-07": "locked",
        "action-23": "Text edited",
        "action-53": "Image width",
        "action-72": "Button width",
        "action-80": "HTML edited",
        "title-14": "Row",
        "title-16": "Message",
        "title-label": "Block",
        "action-09": "restored"
    },
    "mailup-common-row-display-condition-filter": {
        "label": "Select row display conditions",
        "label-all": "All conditions",
        "label-custom-condition": "Custom"
    },
    "mailup-common-row-display-condition-selector": {
        "back": "Back",
        "cancel": "Close",
        "search-not-found": "No results found",
        "search-not-found-message": "Try with a different keyword.",
        "search-placeholder": "Search by keyword",
        "title": "Select a display condition"
    },
    "mailup-common-special-link-selector": {
        "back": "Back",
        "cancel": "Close",
        "search-not-found": "No results found",
        "search-not-found-message": "Try with a different keyword.",
        "search-placeholder": "Search by keyword",
        "title": "Select a link"
    },
    "mailup-common-text-editor-provider": {
        "external-item-title": "More",
        "merge-tags-button-text": "Personal Fields",
        "merge-tags-modal-close-button": "Close",
        "merge-tags-modal-title": "Insert personal field",
        "special-link-default-text": "Special links",
        "special-link-title": "Special links"
    },
    "mailup-common-width-style-color-selector": {
        "styles": {
            "dashed": "dashed",
            "dotted": "dotted",
            "solid": "solid"
        }
    },
    "one-column-button": {
        "mailup-bee-newsletter-modules-button": {
            "label": "<p style='font-family: inherit; font-size: 16px;'>Button</p>"
        }
    },
    "one-column-text": {
        "mailup-bee-newsletter-modules-text": {
            "html": "<p style=\"font-size: 18px;\" data-mce-style=\"font-size: 18px;\">What about me?</p><br /><p style=\"font-size: 14px;\" data-mce-style=\"font-size: 14px;\">I'm a text block ready for your content.</p><br /><p style=\"font-size: 14px;\" data-mce-style=\"font-size: 14px;\">Use the toolbar to change the text properties and insert <a href=\"http://www.example.com\" data-mce-href=\"http://www.example.com\">links</a>.</p>"
        }
    },
    "row-display-condition-custom": {
        "after": "After",
        "after-placeholder": "Insert the end of the conditional statement",
        "all-fields-required-error-message": "Oops! One or more required fields are missing or invalid.",
        "all-fields-required-error-title": "All fields are required",
        "before": "Before",
        "before-placeholder": "Insert the start of the conditional statement",
        "cancel": "Cancel",
        "confirm": "Confirm",
        "description": "Description",
        "description-placeholder": "Enter a brief description",
        "duplicate-entry-error-message": "Oops! You defined a condition that is already available. Please select it from the list or create a new one using a different name, description, and conditions.",
        "duplicate-entry-error-title": "Duplicate found!",
        "name": "Name",
        "name-placeholder": "Enter a name",
        "title-add": "Add a new display condition",
        "title-edit": "Edit display condition"
    },
    "two-columns-image-text": {
        "mailup-bee-newsletter-modules-text": {
            "html": "<p style=\"font-size: 18px;\" data-mce-style=\"font-size: 18px;\">What about me?</p><br /><p style=\"font-size: 14px;\" data-mce-style=\"font-size: 14px;\">I'm a text block ready for your content.</p><br /><p style=\"font-size: 14px;\" data-mce-style=\"font-size: 14px;\">Use the toolbar to change the text properties and insert <a href=\"http://www.example.com\" data-mce-href=\"http://www.example.com\">links</a>.</p>"
        }
    },
    "two-columns-text": {
        "mailup-bee-newsletter-modules-text": {
            "html": "<p style=\"font-size: 18px;\" data-mce-style=\"font-size: 18px;\">What about me?</p><br /><p style=\"font-size: 14px;\" data-mce-style=\"font-size: 14px;\">I'm a text block ready for your content.</p><br /><p style=\"font-size: 14px;\" data-mce-style=\"font-size: 14px;\">Use the toolbar to change the text properties and insert <a href=\"http://www.example.com\" data-mce-href=\"http://www.example.com\">links</a>.</p>"
        }
    },
    "widget-groups": {
        "action-options": "Action",
        "button-options": "Button options",
        "divider-options": "Divider options",
        "icon-options": "Icon options",
        "image-options": "Image options",
        "merge-content-selector": "Select the content to use",
        "module-options": "Module options",
        "page-options": "General options",
        "spacing-options": "Block options",
        "text-options": "Text options",
        "configure-form-elements": "Form elements",
        "labels-options": "Label options",
        "fields-options": "Field options",
        "buttons-options": "Button options",
        "labels-values": "Label values"
    },
    "mailup-common-image-editor": {
        "add-text": "Add Text",
        "align-text": "Align Text",
        "apply": "Apply",
        "aspect-ratio": "Maintain Aspect Ratio",
        "background": "Background",
        "background-color": "Background Color",
        "basic": "Basic",
        "beach": "Beach",
        "black-white": "Black & White",
        "blend": "Blend",
        "blur": "Blur",
        "brightness": "Brightness",
        "brush-color": "Brush Color",
        "brush-size": "Brush Size",
        "brush-type": "Brush Type",
        "bubbles": "Bubbles",
        "cancel": "Cancel",
        "canvas-background": "Canvas Background",
        "close": "Close",
        "clouds": "Clouds",
        "color": "Color",
        "color-picker": "Color Picker",
        "corners": "Corners",
        "crop": "Crop",
        "delete": "Delete",
        "doodles": "Doodles",
        "draw": "Draw",
        "ebony": "Ebony",
        "editor": "Editor",
        "emboss": "Emboss",
        "emoticons": "Emoticons",
        "filter": "Filter",
        "font": "Font",
        "format-text": "Format Text",
        "frame": "Frame",
        "google-fonts": "Google Fonts",
        "gradient": "Gradient",
        "grayscale": "Grayscale",
        "height": "Height",
        "history": "History",
        "invert": "Invert",
        "landmarks": "Landmarks",
        "oak": "Oak",
        "objects": "Objects",
        "offset-x": "Offset X",
        "offset-y": "Offset Y",
        "open": "Open",
        "outline": "Outline",
        "outline-width": "Outline Width",
        "percentages": "Use Percentages",
        "pine": "Pine",
        "radius": "Radius",
        "rainbow": "Rainbow",
        "remove-color": "Remove Color",
        "resize": "Resize",
        "save": "Save",
        "search": "Search...",
        "shadow": "Shadow",
        "shapes": "Shapes",
        "sharpen": "Sharpen",
        "size": "Size",
        "stars": "Stars",
        "stickers": "Stickers",
        "text": "Text",
        "text-style": "Text Style",
        "texture": "Texture",
        "transform": "Transform",
        "transportation": "Transportation",
        "upload": "Upload",
        "width": "Width",
        "zoom": "Zoom",
        "noise": "Noise",
        "places": "Places",
        "seasonal": "Seasonal"
    },
    "mailup-bee-common-widgets-hide-on": {
        "hide-on": "Hide on",
        "mobile": "Mobile",
        "desktop": "Desktop"
    },
    "mailup-bee-common-widgets-text-direction": {
        "label": "Direction",
        "ltr": "LTR",
        "ltr-tooltip": "Left to right",
        "rtl": "RTL",
        "rtl-tooltip": "Right to left"
    },
    "mailup-bee-common-widgets-form": {
        "manage-layout": "Manage layout",
        "toggle-fields": "Toggle fields",
        "manage-form": "Manage form",
        "visible": "Visible",
        "label": "Label",
        "add-field": "Add new field",
        "manage-fields": "Manage fields",
        "no-fields": "There are no fields configured. Please edit the form to add some.",
        "field-type": "Type",
        "field-rows": "Row height",
        "min-value": "Min value",
        "max-value": "Max value",
        "min": "Min",
        "max": "Max",
        "spinner": "Spinner",
        "placeholder": "Placeholder",
        "options": "Options",
        "options-notes": "Type the available options for this field. If you need a label to go with a value, use a pipe \"|\" to separate them (e.g., California | CA)",
        "required": "Required",
        "readonly": "Read only",
        "modal-ok": "Save",
        "modal-cancel": "Cancel",
        "edit-field": "Edit field",
        "field-type-checkbox": "Multiple choice",
        "field-type-date": "Date",
        "field-type-email": "Email",
        "field-type-number": "Number",
        "field-type-radio": "Single choice",
        "field-type-select": "Dropdown",
        "field-type-tel": "Phone",
        "field-type-text": "Text",
        "field-type-textarea": "Long Text",
        "field-type-url": "Url",
        "edit": "Edit"
    },
    "mailup-bee-common-widgets-font-style": {
        "label": "Font style",
        "italic": "Italic",
        "bold": "Bold"
    },
    "mailup-bee-common-widgets-font-size": {
        "label": "Font size"
    },
    "mailup-bee-common-widgets-position": {
        "label": "Label position"
    },
    "mailup-bee-common-widgets-label-position": {
        "top": "Top",
        "side": "Side",
        "left": "Left",
        "right": "Right"
    },
    "mailup-bee-common-widgets-min-width": {
        "label": "Width"
    },
    "mailup-bee-common-widgets-outline": {
        "color": "Active field outline color"
    },
    "mailup-bee-newsletter-modules-form": {
        "name": "Form"
    },
    "mailup-bee-newsletter-modules-icons": {
        "name": "Icons"
    },
    "mailup-bee-common-widgets-iconsize": {
        "label": "Icon size"
    },
    "mailup-bee-newsletter-collaboration": {
        "locked-module-warning-message": "This module is being edited by another user.",
        "locked-module-warning-title": "This module is locked",
        "locked-row-warning-message": "This row is being edited by another user.",
        "locked-row-warning-title": "This row is locked",
        "row-delete-confirm-title": "Are you sure you want to delete this row?",
        "row-delete-confirm-message": "Another user is currently editing a module inside this row. By deleting it, you might cause their work to be lost.",
        "lock-rejected-title": "Element was locked by another user.",
        "lock-rejected-message": "The element is currently being edited by another user. Please wait until they are finished with their changes.",
        "overlay-connecting-message": "Connecting...",
        "overlay-error-message": "Error occurred during the co-editing session",
        "is-editing-suffix": " is editing",
        "page-change-failed-title": "The requested edit could not be applied.",
        "page-change-failed-message": "The edit had a conflict that could not be automatically resolved. Please try again.",
        "delete-rejected-title": "This element cannot be deleted.",
        "delete-rejected-message": "Another user is working in the same row."
    },
    "mailup-bee-newsletter-modules-menu": {
        "name": "Menu"
    },
    "mailup-bee-common-widgets-hamburger-menu": {
        "desktop": "Desktop",
        "mobile": "Mobile",
        "label": "Mobile menu",
        "icon-color": "Foreground color",
        "icon-size": "Icon size",
        "icon-type": "Icon type",
        "background-color": "Background color"
    },
    "mailup-bee-common-widgets-layout": {
        "label": "Layout",
        "horizontal": "Horizontal",
        "vertical": "Vertical"
    },
    "mailup-bee-common-widgets-separator": {
        "label": "Separator"
    },
    "mailup-bee-common-widgets-items-spacing": {
        "label": "Items padding"
    },
    "mailup-bee-common-widgets-menu": {
        "configure-menu": "Configure menu items",
        "add-new-item": "Add new item"
    },
    "mailup-bee-common-widgets-id": {
        "toggle": "Block identifier",
        "id": "ID",
        "description": "The ID can be used as an internal reference in the content. Setting an ID for a module makes it available for selection in the link options. When not automatically generated, make sure to use unique identifiers."
    },
    "mailup-common-menu-organizer": {
        "text": "Text"
    },
    "mailup-bee-common-widgets-row-display-reverse-stack": {
        "label": "Reverse stack order on mobile"
    },
    "mailup-bee-newsletter-modules-carousel": {
        "name": "Carousel"
    },
    "mailup-bee-common-widgets-carousel": {
        "dot-navigation": "Dot navigation",
        "autoplay-interval": "Autoplay interval",
        "slide-delete": "Slide Deleted",
        "slide-update": "Slide Updated",
        "slide-insert": "Slide Inserted",
        "slide-dragged": "Slide Dragged",
        "slide-replace": "Slide Replaced",
        "resize": "Resize Carousel",
        "dot-navigation-color": "Dot navigation color",
        "slide-order-change": "Slide Order Changed",
        "dot-navigation-color-change": "Dot Navigation Color Changed",
        "slide-input-update": "Slide Input Updated",
        "autoplay-interval-change": "Autoplay interval Changed"
    },
    "mailup-bee-common-widgets-itemsspacing": {
        "label": "Icon spacing"
    },
    "mailup-bee-commenting": {
        "edit": "Edit",
        "delete": "Delete",
        "save": "Save",
        "cancel": "Cancel",
        "submit": "Submit",
        "reply": "Reply",
        "allCommentsTitle": "All comments",
        "solvedFilterLabel": "Solved",
        "emptyCommentsPlaceholderMessage": "Insert a new general comment",
        "newCommentPlaceholderMessage": "Insert a new comment",
        "actionResolve": "Resolve",
        "actionReopen": "Reopen",
        "labelResolved": "Resolved",
        "collapsibleShowMoreLabel": "Show more",
        "collapsibleShowLessLabel": "Show less",
        "addCommentFormPlaceholder": "Add comment",
        "showRepliesLabel": "Show all {repliesCount} replies",
        "backToAllCommentsButtonLabel": "Back to all comments",
        "resolveCommentContent": "Marked as resolved",
        "reopenCommentContent": "Reopened",
        "deletedFilterLabel": "Deleted content",
        "labelDeletedModule": "Content deleted"
    },
    "mailup-bee-common-widgets-iconpadding": {
        "label": "Icon padding"
    },
    "mailup-bee-carousel": {
        "configure-carousel": "Configure carousel",
        "first-slide-sizing-rule": "First-positioned image will determine the aspect of the carousel. The following images will adapt their ratio to the carousel.",
        "autoplay": "Autoplay",
        "interval": "Interval",
        "navigation": "Navigation",
        "color": "Color"
    },
    "mailup-bee-common-widgets-message-align": {
        "label": "Content area alignment"
    },
    "mailup-bee-common-widgets-body-align": {
        "label": "Content Area Align",
        "left": "Left",
        "center": "Center",
        "right": "Right"
    },
    "mailup-bee-common-widgets-heading": {
        "update": "Title Updated",
        "text-update": "Title Text Edited",
        "default-text": "I'm a new title block",
        "title": "Title",
        "paragraph": "Text direction"
    },
    "mailup-bee-newsletter-modules-heading": {
        "name": "Title"
    },
    "mailup-bee-common-widgets-attributes": {
        "label": "Attributes",
        "dropdown-label": "Add new attribute",
        "target-link": "Link",
        "target-tag": "Tag"
    },
    "mailup-bee-common-widgets-letter-spacing": {
        "label": "Letter spacing"
    }
}
//#endregion
//#region Hebrew Translation
export const TRANSLATE_HEBREW = {
    "bee-common-top-bar": {
        "actions": "פעולות",
        "help": "עזרה",
        "hide-structure": "הסתר מבנים",
        "preview": "תצוגה מקדימה",
        "save": "שמירה",
        "save-as-template": "שמור כתבנית",
        "send-test": "שליחת ניסיון",
        "settings": "הגדרות",
        "show-json-model": "הצג כג'ייסון",
        "show-structure": "הצב מבנים",
        "hide-comments": "הסתר הערות",
        "show-comments": "הצג הערות"
    },
    "bee-common-widget-bar": {
        "body": "הגדרות",
        "column-properties": "מאפייני עמודה",
        "content": "תוכן",
        "content-properties": "מאפייני תוכן",
        "default-rows": "ברירת מחדל",
        "delete": "מחק",
        "duplicate": "שכפל",
        "empty-rows": "תבניות ריקות",
        "row-alt": "תמונה",
        "row-bkg-over-txt": "טקסט על תבנית רקע",
        "row-bullet-point": "רשימה לא ממוספרת",
        "row-galleries-1": "גלריית תמונות - תמונה ממוזערת ברוחב מלא",
        "row-galleries-2": "גלריית תמונות - שתי עמודות",
        "row-galleries-3": "גלריית תמונות - שלוש עמודות",
        "row-galleries-4": "גלריית תמונות - ארבע עמודות",
        "row-hero-bkg-over-txt": "Hero Image",
        "row-icon-1": "תכונה עיקרית",
        "row-icon-2": "תכונות - שתי עמודות",
        "row-icon-2-left": "תכונות - שתי עמודות",
        "row-icon-3": "תכונות - שלוש עמודות",
        "row-icon-4": "תכונות - ארבע עמודות",
        "row-image-text-1": "מאמר ראשי",
        "row-image-text-2": "מאמרים - שתי עמודות",
        "row-image-text-2-h-left": "מאמר - תמונה מיושרת לשמאל",
        "row-image-text-2-h-right": "מאמר - תמונה מיושרת לימין",
        "row-image-text-3": "מאמרים - שלוש עמודות",
        "row-image-text-4": "מאמרים - ארבע עמודות",
        "row-lg-image-text-left": "מאמר - תמונה גדולה מיושרת לשמאל",
        "row-lg-image-text-right": "מאמר - תמונה גדולה מיושרת לימין",
        "row-paragraph": "לורם איפסום דולור סיט אמט, קונסקטורר אדיפיסינג אלית קולורס מונפרד אדנדום סילקוף, מרגשי ומרגשח. עמחליף לפרומי בלוף קינץ תתיח לרעח. לת צשחמי צש בליא, מנסוטו צמלח לביקו ננבי, צמוקו בלוקריה שיצמה ברורק.",
        "row-properties": "מאפייני שורה",
        "row-sq-image-text-left": "מאמר - תמונה מרובעת - מיושר לשמאל",
        "row-sq-image-text-right": "מאמר - תמונה מרובעת - מיושר לימין",
        "row-text": "לורם איפסום דולור סיט אמט, קונסקטורר אדיפיסינג אלית קולורס מונפרד אדנדום סילקוף.",
        "row-title-": " ",
        "row-title-article": "לורם איפסום דולור סיט אמט",
        "row-title-bullet-point": "קונסקטורר אדיפיסינג אלית.",
        "row-title-drag-drop": "אדנדום סילקוף",
        "row-title-feature": "מרגשיומרגשח",
        "row-title-here": "עמחליף לפרומי בלוף",
        "row-title-hero": "מנסוטו צמלח לביקו",
        "row-title-main": "לת צשחמי צש בליא",
        "row-title-secure": "תתיח לרעח",
        "row-title-subtitle": "עמחליף לפרומי בלוף",
        "row-title-super-fast": "תתיח לרעח",
        "row-title-top-quality": "תתיח לרעח",
        "structure": "שורות",
        "validation-url-empty": "כתובת האתר ריקה.",
        "validation-url-error": "לא ניתן לטעון את כתובת האתר.",
        "validation-url-https": "על כתובת האתר להכיל https.",
        "validation-url-label": "כתובת אתר לא חוקית",
        "empty-state": "לא נמצאו שורות.",
        "save": "שמור",
        "comments": "הצג הערות",
        "add-new-column": "הוסף עמודה חדשה",
        "delete-column": "מחק",
        "column-add": "עמודה נוספה",
        "column-resize": "רוחב העמודה  שונה",
        "column-delete": "עמודה נמחקה",
        "columns-customize": "התאם אישית עמודות"
    },
    "bee-common-widgets-lock": {
        "label-locked": "תווית נעולה",
        "label-unlocked": "תווית לא נעולה"
    },
    "bee-controller": {
        "error-loading-template": "אופס! משהו השתבש בעת טעינת ההודעה שלך.",
        "error-loading-template-title": "שגיאה",
        "warning-loading-template": "ההודעה שלך נטענה במצב תאימות. ייתכן שחלק מהתכונות לא יהיו זמינות.",
        "warning-loading-template-title": "שים לב",
        "error-browser-title": "הדפדפן שלך אינו נתמך",
        "error-browser": "זיהינו דפדפן מיושן (${browserName} ${browserVersion}) שאינו נתמך עוד.",
        "error-browser-details": "יישום זה עובד בצורה הטובה ביותר בדפדפנים כרום, פיירפוקס, אדג' וספארי."
    },
    "bee-newsletter-modules-html": {
        "html": "<div class=\"our-class\" dir=\"rtl\"> אני בלוק HTML חדש. </div>",
        "widget-warning-desc": "שימוש בקוד משלך עשוי להשפיע על אופן עיבוד ההודעה. הקפד להשתמש ב-HTML נכון ומגיב.",
        "widget-warning-title": "מומחי HTML בלבד"
    },
    "column-property-titles": {
        "1": "עמודה 1",
        "2": "עמודה 2",
        "3": "עמודה 3",
        "4": "עמודה 4",
        "5": "עמודה 5",
        "6": "עמודה 6",
        "7": "עמודה 7",
        "8": "עמודה 8",
        "9": "עמודה 9",
        "10": "עמודה 10",
        "11": "עמודה 11",
        "12": "עמודה 12",
        "four-columns-empty": "ארבע עמודות",
        "Four-columns-images": "קבוצת תמונות רחבה",
        "one-column-button": "כפתור פעולה",
        "one-column-empty": "עמודה אחת",
        "one-column-image": "Hero image",
        "one-column-text": "טקסט רחב",
        "three-columns-empty": "שלוש עמודות",
        "three-columns-images": "קבוצת תמונות",
        "two-columns-4-8-empty": "סרגל צד משמאל",
        "two-columns-8-4-empty": "סרגל צד מימין",
        "two-columns-empty": "שתי עמודות",
        "two-columns-image-text": "טקסט ואייקון",
        "two-columns-text": "טקסט כפול"
    },
    "mailup-bee-app": {
        "prevent-close-confirm": "ביציאה מדף זה השינויים שלך יאבדו! האם אתה באמת רוצה לעזוב את הדף הזה?"
    },
    "mailup-bee-common-widgets-align": {
        "label": "יישר"
    },
    "mailup-bee-common-widgets-alt": {
        "label": "טקסט חלופי"
    },
    "mailup-bee-common-widgets-background-color": {
        "label": "צבע רקע"
    },
    "mailup-bee-common-widgets-background-color-column": {
        "label": "רקע עמודה"
    },
    "mailup-bee-common-widgets-background-color-content": {
        "label": "צבע רקע התוכן"
    },
    "mailup-bee-common-widgets-background-color-row": {
        "label": "צבע רקע השורה"
    },
    "mailup-bee-common-widgets-background-image": {
        "center": "מרכז",
        "change-image": "שנה תמונה",
        "description": "שים לב שתמונות הרקע אינן תואמות לכל תוכנות הדואר האלקטרוני. כאשר אינן נתמכות, צבע הרקע של השורה ישמש במקום זאת. אז ודא שהצבע עובד היטב עם התוכן שלך.",
        "disabled": "מושבת",
        "edit": "החל אפקטים ועוד",
        "enabled": "מופעל",
        "fullwidth": "רוחב מלא",
        "label": "תמונת רקע של שורה",
        "name": "שם תמונה",
        "repeat": "חזור",
        "url": "כתובת אתר"
    },
    "mailup-bee-common-widgets-border": {
        "all-sides": "כל הצדדים",
        "bottom": "למטה",
        "label": "גבול",
        "left": "שמאלה",
        "more-options": "אפשרויות נוספות",
        "right": "ימינה",
        "top": "למעלה"
    },
    "mailup-bee-common-widgets-border-radius": {
        "label": "רדיוס גבול"
    },
    "mailup-bee-common-widgets-button-link-type": {
        "label": "סוג קישור"
    },
    "mailup-bee-common-widgets-button-width": {
        "label": "רוחב אוטומטי"
    },
    "mailup-bee-common-widgets-color": {
        "label": "צבע טקסט"
    },
    "mailup-bee-common-widgets-divider-mode": {
        "align": "יישר",
        "height": "גובה",
        "label": "שקוף",
        "line": "קו",
        "width": "רוחב"
    },
    "mailup-bee-common-widgets-dynamic-image": {
        "description": "כאשר 'תמונה דינאמית' מופעלת, 'כתובת אתר' הופכת למיקום של תמונה לדוגמה המוצגת בעורך. 'כתובת אתר דינמית' תשמש בקוד ה-HTML. גודל התמונה הדינמית יוגדר על סמך על הדוגמה, אז השתמש בתמונה לדוגמה באותו גודל.",
        "disabled": "מושבת",
        "enabled": "מופעל",
        "label": "תמונה דינאמית",
        "src": "כתובת אתר דינאמית"
    },
    "mailup-bee-common-widgets-font": {
        "body-label": "גופן ברירת מחדל",
        "label": "משפחת גופנים"
    },
    "mailup-bee-common-widgets-hide-on-mobile": {
        "label": "הסתר במובייל"
    },
    "mailup-bee-common-widgets-icons": {
        "configure-icon-collection": "הגדר אוסף אייקונים",
        "select-icon-collection": "בחר אוסף אייקונים"
    },
    "mailup-bee-common-widgets-icons-align-and-space": {
        "align": "יישר",
        "icon-spacing": "ריווח אייקונים"
    },
    "mailup-bee-common-widgets-image-align": {
        "align": "יישר",
        "autowidth": "רוחב אוטומטי",
        "fullwidth": "התאמה לרוחב",
        "fullwidth-blocked": "תמונה זו גדולה יותר מהמכל, ולכן היא מוגדרת אוטומטית ל'התאמה לרוחב'.",
        "fullwidthOnMobile": "רוחב מלא במובייל",
        "label": "יישר",
        "pixels-tooltip-label": "px",
        "switch-off-automatic": "כבה את 'שינוי גודל תמונה אוטומטי' כדי לשנות את גודל התמונה באופן ידני.."
    },
    "mailup-bee-common-widgets-image-editor": {
        "label": "החל אפקטים ועוד"
    },
    "mailup-bee-common-widgets-image-href": {
        "label": "קישור לתמונה"
    },
    "mailup-bee-common-widgets-image-selector": {
        "edit": "החל אפקטים ועוד",
        "label": "שנה תמונה",
        "name": "קישור לתמונה",
        "url": "כתובת אתר"
    },
    "mailup-bee-common-widgets-line-height": {
        "label": "גובה קו"
    },
    "mailup-bee-common-widgets-link-color": {
        "label": "צבע קישור"
    },
    "mailup-bee-common-widgets-message-background-color": {
        "label": "צבע רקע של אזור התוכן"
    },
    "mailup-bee-common-widgets-message-width": {
        "label": "רוחב אזור התוכן"
    },
    "mailup-bee-common-widgets-padding": {
        "all-sides": "כל הצדדים",
        "bottom": "למטה",
        "label": "ריווח",
        "left": "שמאל",
        "more-options": "אפשרויות נוספות",
        "right": "ימין",
        "top": "למעלה"
    },
    "mailup-bee-common-widgets-padding-content": {
        "label": "ריווח תוכן"
    },
    "mailup-bee-common-widgets-row-display-condition": {
        "add": "הוסף תנאי",
        "after": "אחרי",
        "before": "לפני",
        "change": "שנה מצב",
        "delete": "הסרה משורה",
        "delete-confirmation-description": "על מנת להסיר את התנאי משורה ספציפית זו, צאו מהפופ אפ ולחצו \"הסרה משורה\"",
        "delete-confirmation-no": "לא, שמור אותו",
        "delete-confirmation-title": "האם אתה באמת רוצה להסיר תנאי זה משורה זו?",
        "delete-confirmation-yes": "כן, הסר אותו",
        "description": "תיאור",
        "edit": "עריכת תנאי",
        "label": "הצג תנאי",
        "name": "שם",
        "no-condition": "לא הוחל תנאי תצוגה על שורה זאת",
        "remove": "הסרה משורה",
        "select": "בחר תנאי"
    },
    "mailup-bee-common-widgets-row-display-flow-row": {
        "label": "שמור סדר מבנים במובייל"
    },
    "mailup-bee-common-widgets-text-align": {
        "label": "יישר"
    },
    "mailup-bee-common-widgets-video-content": {
        "arrow": "חץ בלבד",
        "dark": "חשוך",
        "description": "Add a <a href=\"https://www.youtube.com\" target=\"_blank\">YouTube</a> or <a href=\"https://vimeo.com\" target=\"_blank\">Vimeo</a> URL to automatically generate a preview image. The image will link to the provided URL.",
        "full": "Solid",
        "icon-color": "צבע כפתור הפעל",
        "icon-preview": "תצוגת כפתור הפעל",
        "icon-size": "גודל כפתור הפעל",
        "icon-type": "סוג כפתור הפעל",
        "label": "URL וידאו",
        "light": "מואר",
        "outline": "מתאר",
        "rectangle": "מלבני",
        "round": "עגול",
        "square": "מרובע",
        "embedded": "מוטמע",
        "thumbnail": "תמונה ממוזערת",
        "custom": "סרטון משותף",
        "autoplay": "הפעלה אוטומטית",
        "controls": "כפתורים",
        "loop": "לולאה"
    },
    "mailup-bee-common-widgets-width": {
        "label": "רוחב"
    },
    "mailup-bee-newsletter-modules-button": {
        "label": "<p style='font-family: inherit; font-size: 16px;'>Button</p>",
        "name": "כפתור"
    },
    "mailup-bee-newsletter-modules-divider": {
        "name": "מפריד"
    },
    "mailup-bee-newsletter-modules-empty": {
        "label": "אין כאן תוכן. גרור חדש מחלונית 'תוכן'.",
        "name": "ריק"
    },
    "mailup-bee-newsletter-modules-html": {
        "name": "HTML"
    },
    "mailup-bee-newsletter-modules-image": {
        "browse": "עיין",
        "drop-here": "הנח את הקובץ שלך כאן",
        "name": "תמונה"
    },
    "mailup-bee-newsletter-modules-merge-content": {
        "name": "תוכן דינאמי"
    },
    "mailup-bee-newsletter-modules-social": {
        "name": "רשתות חברתיות"
    },
    "mailup-bee-newsletter-modules-text": {
        "html": "<p style='font-size: 14px;'>I&apos;m a new Text block ready for your content.</p>",
        "name": "טקסט"
    },
    "mailup-bee-newsletter-modules-video": {
        "description": "וידאו",
        "label": "הוספת כתובת אינטרנט לוידאו",
        "name": "וידאו"
    },
    "mailup-bee-newsletter-stage": {
        "cancel": "בטל",
        "delete": "מחק",
        "delete-configrmation-message": "לא ניתן לבטל פעולה זו.",
        "delete-configrmation-title": "האם אתה בטוח שאתה רוצה למחוק את זה?",
        "delete-module-in-locked-row-error-message": "שורה זו נעולה ולכן לא ניתן לערוך את התוכן שלה.",
        "delete-module-in-locked-row-error-title": "לא ניתן למחוק את בלוק התוכן הזה",
        "delete-row-locked-content-error-message": "שורה זו מכילה תוכן נעול ולכן לא ניתן למחוק אותה.",
        "delete-row-locked-content-error-title": "לא ניתן למחוק שורה זו",
        "drag-it-here": "גרור לכאן",
        "duplicate-module-in-locked-row-error-message": "שורה זו נעולה ולכן לא ניתן לשכפל את התוכן שלה.",
        "duplicate-module-in-locked-row-error-title": "לא ניתן לשכפל את בלוק התוכן הזה",
        "duplicate-row-locked-content-error-message": "שורה זו מכילה תוכן נעול ולכן לא ניתן לשכפל אותה.",
        "duplicate-row-locked-content-error-title": "לא ניתן לשכפל שורה זו",
        "locked-module-warning-message": "לא ניתן לערוך בלוקי תוכן נעולים.",
        "locked-module-warning-title": "תוכן זה נעול",
        "locked-row-warning-message": "שורה זו נעולה ולכן לא ניתן לערוך את התוכן שלה.",
        "locked-row-warning-title": "שורה זו נעולה",
        "delete-column-confirmation-message": "כל המודולים בעמודה זו יימחקו גם הם.<br>לא ניתן לבטל פעולה זו."
    },
    "mailup-common-file-manager": {
        "action-delete": "מחק",
        "action-insert": "הכנס",
        "action-preview": "הצג",
        "add-folder": "הוסף תיקייה",
        "add-new-file": "העלה",
        "cancel": "בטל",
        "close": "סגור",
        "delete": "מחק",
        "delete-confirm-message": "לא ניתן לבטל פעולה זו.",
        "delete-confirm-title": "האם אתה בטוח שברצונך למחוק את הקובץ הזה?",
        "delete-folder-button": "סגור",
        "delete-folder-text": "לפני מחיקתו עליך למחוק או להעביר את התוכן שלו",
        "delete-folder-title": "תיקיה זו אינה ריקה",
        "drag-to-upload": "גרור את הקבצים שלך לכאן",
        "empty-folder": "תיקיה ריקה, העלה כמה קבצים לכאן.",
        "error-1055": "שם המשתמש שלך כבר בשימוש. זה עשוי לקרות אם היישום נפתח בחלונות דפדפן מרובים, או שאתה משתמש בחשבון משותף.",
        "error-1055-title": "שגיאת אימות",
        "error-3001": "אנא נסה שוב.",
        "error-3001-title": "אופס! משהו השתבש.",
        "error-3100": "משהו השתבש במהלך הגישה למערכת הקבצים.",
        "error-3100-title": "אופס! משהו השתבש.",
        "error-3200": "הקובץ או הספרייה לא נמצאו.",
        "error-3200-title": "לא נמצא המשאב.",
        "error-3300": "נדחתה ההרשאה לגשת לקובץ או ספרייה.",
        "error-3300-title": "הרשאה נדחתה.",
        "error-3400": "קובץ או ספרייה כבר קיימים.",
        "error-3400-title": "משאב כבר קיים.",
        "error-3450": "שגיאה במהלך העלאת קובץ.",
        "error-3450-title": "הקובץ לא הועלה.",
        "error-3500": "השרת לא הצליח להבין את הבקשה עקב תחביר לא חוקי.",
        "error-3500-title": "שגיאת בקשה.",
        "error-3600": "Not a valid S3 custom storage.",
        "error-3600-title": "אופס! משהו השתבש.",
        "error-3650": "שם משתמש או סיסמה שגויים.",
        "error-3650-title": "לא מורשה.",
        "error-400": "אנא נסה שוב.",
        "error-400-title": "אופס! משהו השתבש.",
        "error-403": "אין לך הרשאה לגשת לקובץ זה או לספרייה זו.",
        "error-403-title": "אופס! משהו השתבש.",
        "error-404": "הקובץ או הספרייה לא נמצאו.",
        "error-404-title": "אופס! משהו השתבש.",
        "error-409": "הקובץ או הספרייה כבר קיימים.",
        "error-409-title": "אופס! משהו השתבש.",
        "error-503": "אנא נסה שנית.",
        "error-503-title": "אופס! משהו השתבש.",
        "error-generic": "אופס! משהו השתבש.",
        "error-generic-title": "שגיאה",
        "error-uploading": "אופס! משהו השתבש בעת העלאת התמונה.",
        "error-uploading-title": "שגיאת העלאה",
        "grid-view": "תצוגת רשת",
        "import-file": "ייבוא",
        "list-view": "תצוגת רשימה",
        "load-more": "טען עוד",
        "multi-delete-confirm-title": "האם אתה בטוח שאתה רוצה למחוק את הקובץ הזה של {{multiDeleteItems}}?",
        "multiselect-actions": "פעולות",
        "multiselect-delete-all": "מחק הכל",
        "multiselect-move-all": "הזז הכל",
        "new-folder-placeholder": "שם התיקייה",
        "overwrite": "שכתב",
        "overwrite-confirm-message": "קובץ שהועלה בעבר באותו שם יוחלף.פעולה זו לא ניתנת לביטול.",
        "overwrite-confirm-title": "האם אתה בטוח שברצונך להחליף את הקובץ הזה?",
        "read-only": "לקריאה בלבד",
        "read-only-tooltip": "תווית זו מציינת שאינך יכול לשנות את התוכן של תיקיה זו. אנא דפדף לתיקיה אחרת ונסה שוב.",
        "root-folder": "בית",
        "search-free-photos": "חפש תמונות בחינם",
        "search-noresults-text": "נסה עם מונח אחר או שנה תיקיה",
        "search-noresults-title": "לא נמצאו תוצאות עבור",
        "search-not-found": "לא נמצאה תוצאה",
        "search-not-found-message": "נסה עם משהו אחר.",
        "search-placeholder": "חפש בתיקייה",
        "select-all": "בחר הכל",
        "select-file": "בחר קובץ",
        "sort-date": "תאריך",
        "sort-name": "שם",
        "sort-size": "גודל",
        "sort-type": "סוג",
        "stats": "מציג {{visibleItems}} פריטים של {{totalItems}}",
        "stock-images-creative-commons": "All images are published under the <strong>Creative Commons Zero</strong> license",
        "stock-images-description": "מצא תמונות באיכות גבוהה עבור הקמפיינים שלך <strong>יותר מ-50,000 תמונות מלאי.</strong>",
        "stock-images-import": "ייבא",
        "stock-images-no-result-description": "אנא, בדוק את האיות או נסה מונחים לא ספציפיים יותר.",
        "stock-images-no-result-title": "מצטערים, לא הצלחנו למצוא תמונות שתואמות לחיפוש שלך",
        "stock-images-popular-images": "תמונות פופולריות",
        "stock-images-powered-by": "מופעל על ידי",
        "stock-images-random-images": "תמונות אקראיות",
        "stock-images-search-alternatives": "או חפש...",
        "stock-images-search-for": "תוצאות עבור",
        "stock-images-search-placeholder": "חפש תמונות",
        "stock-images-status": "{{pageCount}} מתוך {{totalCount}} תמונות",
        "stock-images-title": "חפש תמונות בחינם",
        "title": "מנהל קבצים",
        "type-directory": "תיקיה",
        "type-document": "מסמך",
        "type-image": "תמונה",
        "upload-completed": "ההעלאה הושלמה",
        "upload-inprogress": "העלאה מתבצעת",
        "upload-status-current": "הושלמו {{items}} מתוך {{totalItems}} העלאות.",
        "upload-status-error": "לא ניתן היה להעלות {{items}} מתוך {{totalItems}} קבצים.",
        "upload-status-queued": "תמונה נוספה לתור",
        "upload-wait": "כמעט סיימנו...",
        "validation-name-is-required": "נדרש",
        "validation-name-maximum": "חייב להיות קצר מ-%{count} תווים",
        "validation-name-minium": "חייב להיות גדול מ-%{count} תווים",
        "validation-name-special-characters": "מכיל תווים לא חוקיים (< > : \" / \\\\ | ? * הם תווים אסורים)",
        "warning-cant-create-folder-body": "התווית {{readOnly}} מציינת שאינך יכול לשנות את התוכן של תיקיה זו. אנא דפדף לתיקיה אחרת ונסה שוב.",
        "warning-cant-create-folder-title": "אזהרה! אינך יכול ליצור שום תיקיה בתוך תיקיה זו.",
        "warning-cant-upload-body": "התווית {{readOnly}} מציינת שאינך יכול לשנות את התוכן של תיקיה זו. אנא דפדף לתיקיה אחרת ונסה שוב.",
        "warning-cant-upload-title": "אזהרה! אינך יכול להעלות קבצים לתיקיה זו.",
        "warning-delete-files": "לא ניתן למחוק קובץ זה",
        "warning-delete-folder": "ניתן למחוק תיקיות ריקות בלבד",
        "warning-edit": "לא ניתן לערוך תוכן הזה",
        "warning-unsupported-file-extension": "אופס, יש בעיה בהעלאת הקובץ שלך.\nפורמט הקובץ אינו נתמך.",
        "error-3903-title": "תווים לא חוקיים",
        "error-3903": "השם מכיל תווים לא חוקיים",
        "error-3410-title": "הקובץ לא הועלה.",
        "error-3410": "הקובץ חורג מהגודל המרבי המותר.",
        "error-3420-title": "הקובץ לא הועלה.",
        "error-3420": "סיומת שם הקובץ היא חובה.",
        "error-3430": "סוג הקובץ אינו מותר.",
        "error-3430-title": "הקובץ לא הועלה."
    },
    "mailup-common-font-selector": {
        "page-font": "גופן ברירת מחדל"
    },
    "mailup-common-href": {
        "link-file": "קישור לקובץ",
        "link-sms": "טלפון",
        "link-telephone": "טלפון",
        "link-url": "כתובת אתר",
        "special-link": "קישורים מיוחדים",
        "anchor": "גלול אל"
    },
    "mailup-common-icons-organizer": {
        "add-new-icon": "הוסף אייקון חדש",
        "alt": "טקסט חלופי",
        "close": "סגור",
        "close-panel": "סגור לוח",
        "edit": "ערוך",
        "follow": "מעקב רשתות חברתיות",
        "link-placeholder": "השלם או הכנס את כתובת האתר",
        "more-options": "אפשרויות נוספות",
        "others": "אייקונים אחרים",
        "remove": "הסר",
        "share": "שיתוף רשתות חבריות",
        "title": "כותרת",
        "url": "כתובת אתר",
        "resize": "שינוי גודל ועוד",
        "custom": "מותאם אישית",
        "change": "שנה אייקון",
        "add-custom": "הוסף אייקון מותאם אישית",
        "image-url": "URL תמונה",
        "text": "טקסט אייקון",
        "text-position": "מיקום טקסט",
        "target": "יעד",
        "target-blank": "דף חדש",
        "target-self": "דף נוכחי",
        "top": "למעלה",
        "right": "ימינה",
        "bottom": "למטה",
        "left": "שמאלה"
    },
    "mailup-common-language-selector": {
        "de-DE": "גרמנית",
        "en-US": "אנגלית",
        "es-ES": "ספרדית",
        "fr-FR": "צרפתית",
        "it-IT": "איטלקית",
        "tr-TR": "טורקית",
        "zh-CN": "מנדרינית"
    },
    "mailup-common-link-type-selector": {
        "body": "גוף",
        "email-address": "שלח דוא\"ל",
        "link-type": "סוג קישור",
        "mail-to": "שלח דוא\"ל ל",
        "maps": "הצג מפה",
        "subject": "נושא",
        "telephone": "בצע שיחה",
        "text": "שלח SMS",
        "web-address": "פתח דף אינטרנט",
        "anchor": "קישור פנימי"
    },
    "mailup-common-page-preview": {
        "desktop": "שולחן עבודה",
        "disclaimer-description": "הצגת אימייל באופן עקבי בין מכשירים היא אתגר. עיצוב רספונסיבי מספק פתרון. הודעה זו תוצג כהלכה בלקוחות מובייל רבים. גרסת שולחן העבודה תשמש כאשר עיצוב רספונסיבי אינו נתמך.",
        "disclaimer-title": "איך זה ייראה?",
        "error": "אופס! משהו השתבש בתצוגה המקדימה.",
        "error-title": "שגיאה בתצוגה מקדימה",
        "mobile": "מובייל",
        "preview-mode": "מצב תצוגה מקדימה"
    },
    "mailup-common-patch-provider": {
        "action-00": "ירד",
        "action-01": "נגרר",
        "action-02": "נמחק",
        "action-03": "שוכפל",
        "action-04": "שונה",
        "action-05": "נפתח",
        "action-06": "נסגר",
        "action-07": "נעול",
        "action-23": "הטקסט נערך",
        "action-53": "רוחב תמונה",
        "action-72": "רוחב כפתור",
        "action-80": "HTML נערך",
        "title-14": "שורה",
        "title-16": "הודעה",
        "title-label": "חסום",
        "action-09": "שוחזר"
    },
    "mailup-common-row-display-condition-filter": {
        "label": "בחר תנאי הצגת שורה",
        "label-all": "כל התנאים",
        "label-custom-condition": "מותאם אישית"
    },
    "mailup-common-row-display-condition-selector": {
        "back": "חזרה",
        "cancel": "סגור",
        "search-not-found": "לא נמצאו תוצאות",
        "search-not-found-message": "נסה עם מילת חיפוש אחרת.",
        "search-placeholder": "חפש לפי מילת מפתח",
        "title": "בחר תנאי תצוגה"
    },
    "mailup-common-special-link-selector": {
        "back": "חזזרה",
        "cancel": "סגור",
        "search-not-found": "לא נמצאו תוצאות",
        "search-not-found-message": "נסה עם מילת חיפוש אחרת.",
        "search-placeholder": "חפש לפי מילת מפתח",
        "title": "בחר קישור"
    },
    "mailup-common-text-editor-provider": {
        "external-item-title": "עוד",
        "merge-tags-button-text": "שדות אישיים",
        "merge-tags-modal-close-button": "סגור",
        "merge-tags-modal-title": "הוסף תגיות ממוזגות",
        "special-link-default-text": "קישורים מיוחדים",
        "special-link-title": "קישורים מיוחדים"
    },
    "mailup-common-width-style-color-selector": {
        "styles": {
            "dashed": "מקווקו",
            "dotted": "מנוקד",
            "solid": "רציף"
        }
    },
    "one-column-button": {
        "mailup-bee-newsletter-modules-button": {
            "label": "<p style='font-family: inherit; font-size: 16px;'>Button</p>"
        }
    },
    "one-column-text": {
        "mailup-bee-newsletter-modules-text": {
            "html": "<p style=\"font-size: 18px;\" data-mce-style=\"font-size: 18px;\">What about me?</p><br /><p style=\"font-size: 14px;\" data-mce-style=\"font-size: 14px;\">I'm a text block ready for your content.</p><br /><p style=\"font-size: 14px;\" data-mce-style=\"font-size: 14px;\">Use the toolbar to change the text properties and insert <a href=\"http://www.example.com\" data-mce-href=\"http://www.example.com\">links</a>.</p>"
        }
    },
    "row-display-condition-custom": {
        "after": "אחרי",
        "after-placeholder": "הוסף את סוף ההצהרה המותנית",
        "all-fields-required-error-message": "אופס! שדה חובה אחד או יותר חסר או לא חוקי.",
        "all-fields-required-error-title": "כל השדות נדרשים",
        "before": "לפני",
        "before-placeholder": "הוסף את ההתחלה של ההצהרה המותנית",
        "cancel": "ביטול",
        "confirm": "אישור",
        "description": "תיאור",
        "description-placeholder": "הזן תיאור קצר",
        "duplicate-entry-error-message": "אופס! הגדרת תנאי שכבר זמין. אנא בחר אותו מהרשימה או צור אחד חדש באמצעות שם, תיאור ותנאים אחרים.",
        "duplicate-entry-error-title": "נמצא שכפול!",
        "name": "שם",
        "name-placeholder": "הזן שם",
        "title-add": "הוסף תנאי תצוגה חדש",
        "title-edit": "ערוך את מצב התצוגה"
    },
    "two-columns-image-text": {
        "mailup-bee-newsletter-modules-text": {
            "html": "<p style=\"font-size: 18px;\" data-mce-style=\"font-size: 18px;\">What about me?</p><br /><p style=\"font-size: 14px;\" data-mce-style=\"font-size: 14px;\">I'm a text block ready for your content.</p><br /><p style=\"font-size: 14px;\" data-mce-style=\"font-size: 14px;\">Use the toolbar to change the text properties and insert <a href=\"http://www.example.com\" data-mce-href=\"http://www.example.com\">links</a>.</p>"
        }
    },
    "two-columns-text": {
        "mailup-bee-newsletter-modules-text": {
            "html": "<p style=\"font-size: 18px;\" data-mce-style=\"font-size: 18px;\">What about me?</p><br /><p style=\"font-size: 14px;\" data-mce-style=\"font-size: 14px;\">I'm a text block ready for your content.</p><br /><p style=\"font-size: 14px;\" data-mce-style=\"font-size: 14px;\">Use the toolbar to change the text properties and insert <a href=\"http://www.example.com\" data-mce-href=\"http://www.example.com\">links</a>.</p>"
        }
    },
    "widget-groups": {
        "action-options": "פעולה",
        "button-options": "אפשרויות כפתורים",
        "divider-options": "אפשרויות מפריד",
        "icon-options": "אפשרויות אייקונים",
        "image-options": "אפשרויות תמונה",
        "merge-content-selector": "בחר את התוכן לשימוש",
        "module-options": "אפשרויות מודול",
        "page-options": "אפשרויות כלליות",
        "spacing-options": "אפשרויות בלוק",
        "text-options": "אפשרויות טקסט",
        "configure-form-elements": "רכיבי טופס",
        "labels-options": "אפשרויות תוויות",
        "fields-options": "אפשרויות שדה",
        "buttons-options": "אפשרויות כפתורים",
        "labels-values": "ערכי תוויות"
    },
    "mailup-common-image-editor": {
        "add-text": "הוסף טקסט",
        "align-text": "יישר טקסט",
        "apply": "החל",
        "aspect-ratio": "שמור על פרופורציות",
        "background": "רקע",
        "background-color": "צבע רקע",
        "basic": "בסיסי",
        "beach": "חוף",
        "black-white": "שחור לבן",
        "blend": "ערבוב",
        "blur": "מטושטש",
        "brightness": "בהירות",
        "brush-color": "צבע מברשת",
        "brush-size": "גודל מברשת",
        "brush-type": "סוג מברשת",
        "bubbles": "בועות",
        "cancel": "ביטול",
        "canvas-background": "רקע קנבס",
        "close": "סגור",
        "clouds": "עננים",
        "color": "צבע",
        "color-picker": "דוגם צבעים",
        "corners": "פינות",
        "crop": "חתוך",
        "delete": "מחק",
        "doodles": "שרבוטים",
        "draw": "צייר",
        "ebony": "Ebony",
        "editor": "עורך",
        "emboss": "הבלטה",
        "emoticons": "הבעות",
        "filter": "פילטר",
        "font": "גופן",
        "format-text": "פורמט טקסט",
        "frame": "מסגרת",
        "google-fonts": "Google Fonts",
        "gradient": "גרדיאנט",
        "grayscale": "גווני אפור",
        "height": "גובה",
        "history": "היסטוריה",
        "invert": "הפוך",
        "landmarks": "נקודות ציון",
        "oak": "אלון",
        "objects": "אובייקטים",
        "offset-x": "ציר X",
        "offset-y": "ציר Y",
        "open": "פתח",
        "outline": "מתאר",
        "outline-width": "רוחב מתאר",
        "percentages": "השתמש באחוזים",
        "pine": "אורן",
        "radius": "רדיוס",
        "rainbow": "קשת בענן",
        "remove-color": "הסר צבע",
        "resize": "שנה גודל",
        "save": "שמור",
        "search": "חפש...",
        "shadow": "צל",
        "shapes": "צורות",
        "sharpen": "חדד",
        "size": "גודל",
        "stars": "כוכבים",
        "stickers": "מדבקות",
        "text": "טקסט",
        "text-style": "סגנון טקסט",
        "texture": "טקסטורה",
        "transform": "שנה צורה",
        "transportation": "תחבורה",
        "upload": "העלה",
        "width": "רוחב",
        "zoom": "זום",
        "noise": "רעש",
        "places": "מקומות",
        "seasonal": "עונתי"
    },
    "mailup-bee-common-widgets-hide-on": {
        "hide-on": "הסתר ב",
        "mobile": "מובייל",
        "desktop": "תצוגה רגילה"
    },
    "mailup-bee-common-widgets-text-direction": {
        "label": "כיוון",
        "ltr": "משמאל לימין",
        "ltr-tooltip": "משמאל לימין",
        "rtl": "מימין לשמאל",
        "rtl-tooltip": "מימין לשמאל",
    },
    "mailup-bee-common-widgets-form": {
        "manage-layout": "נהל מערך",
        "toggle-fields": "גלול שדות",
        "manage-form": "נהל טופס",
        "visible": "גלוי",
        "label": "תווית",
        "add-field": "הוסף שדה חדש",
        "manage-fields": "נהל שדות",
        "no-fields": "אין שדות מוגדרים. אנא ערוך את הטופס כדי להוסיף כמה שדות.",
        "field-type": "סוג",
        "field-rows": "גובה שורה",
        "min-value": "ערך מינימלי",
        "max-value": "ערך מקסימלי",
        "min": "מינימום",
        "max": "מקסימום",
        "spinner": "Spinner",
        "placeholder": "מציין מקום",
        "options": "אפשריות",
        "options-notes": "הקלד את האפשרויות הזמינות עבור שדה זה. אם אתה צריך תווית שתתאים לערך, השתמש בצינור \"|\" כדי להפריד ביניהן (לדוגמה, קליפורניה | CA)",
        "required": "נדרש",
        "readonly": "לקריאה בלבד",
        "modal-ok": "שמור",
        "modal-cancel": "בטל",
        "edit-field": "ערוך שדה",
        "field-type-checkbox": "בחירה מרובה",
        "field-type-date": "תאריך",
        "field-type-email": "אימייל",
        "field-type-number": "מספר",
        "field-type-radio": "בחירה יחידה",
        "field-type-select": "תפריט דרופדאון",
        "field-type-tel": "טלפון",
        "field-type-text": "טקסט",
        "field-type-textarea": "טקסט ארוך",
        "field-type-url": "Url",
        "edit": "ערוך"
    },
    "mailup-bee-common-widgets-font-style": {
        "label": "גודל גופן",
        "italic": "Italic",
        "bold": "מודגש"
    },
    "mailup-bee-common-widgets-font-size": {
        "label": "גודל גופן"
    },
    "mailup-bee-common-widgets-position": {
        "label": "מיקום תווית"
    },
    "mailup-bee-common-widgets-label-position": {
        "top": "למעלה",
        "side": "בצד",
        "left": "שמאל",
        "right": "ימין"
    },
    "mailup-bee-common-widgets-min-width": {
        "label": "רוחב"
    },
    "mailup-bee-common-widgets-outline": {
        "color": "צבע מתאר שדה פעיל"
    },
    "mailup-bee-newsletter-modules-form": {
        "name": "טופס"
    },
    "mailup-bee-newsletter-modules-icons": {
        "name": "אייקונים"
    },
    "mailup-bee-common-widgets-iconsize": {
        "label": "גודל אייקונים"
    },
    "mailup-bee-newsletter-collaboration": {
        "locked-module-warning-message": "מודול זה עובר עריכה על ידי משתמש אחר.",
        "locked-module-warning-title": "מודול זה נעול",
        "locked-row-warning-message": "שורה זו עוברת עריכה על ידי משתמש אחר.",
        "locked-row-warning-title": "שורה זו נעולה",
        "row-delete-confirm-title": "האם אתה בטוח שברצונך למחוק את השורה הזו?",
        "row-delete-confirm-message": "משתמש אחר עורך כעת מודול בתוך שורה זו. על ידי מחיקתו, אתה עלול לגרום לאיבוד עבודתו.",
        "lock-rejected-title": "הרכיב ננעל על ידי משתמש אחר.",
        "lock-rejected-message": "הרכיב נמצא כעת בעריכה של משתמש אחר. אנא המתן עד שמשתמש זה יסיים עם השינויים שלו.",
        "overlay-connecting-message": "מתחבר...",
        "overlay-error-message": "אירעה שגיאה במהלך הפעלת העריכה המשותפת",
        "is-editing-suffix": "עריכה",
        "page-change-failed-title": "לא ניתן להחיל את העריכה המבוקשת.",
        "page-change-failed-message": "לעריכה הייתה התנגשות שלא ניתן לפתור אוטומטית. אנא נסה שוב.",
        "delete-rejected-title": "לא ניתן למחוק רכיב זה.",
        "delete-rejected-message": "משתמש אחר עובד באותה שורה."
    },
    "mailup-bee-newsletter-modules-menu": {
        "name": "תפריט"
    },
    "mailup-bee-common-widgets-hamburger-menu": {
        "desktop": "שולחן עבודה",
        "mobile": "מובייל",
        "label": "תפריט מובייל",
        "icon-color": "צבע רקע קדמי",
        "icon-size": "גודל אייקון",
        "icon-type": "סוג אייקון",
        "background-color": "צבע רקע"
    },
    "mailup-bee-common-widgets-layout": {
        "label": "מערך",
        "horizontal": "אופקי",
        "vertical": "אנכי"
    },
    "mailup-bee-common-widgets-separator": {
        "label": "מפריד"
    },
    "mailup-bee-common-widgets-items-spacing": {
        "label": "ריווח פריטים"
    },
    "mailup-bee-common-widgets-menu": {
        "configure-menu": "הגדר פריטי תפריט",
        "add-new-item": "הוסף פריט חדש"
    },
    "mailup-bee-common-widgets-id": {
        "toggle": "חסום מזהה",
        "id": "ID",
        "description": "המזהה יכול לשמש כאסמכתא פנימית בתוכן. הגדרת מזהה למודול הופכת אותו לבחירה באפשרויות הקישור. כאשר אינו נוצר אוטומטית, הקפד להשתמש במזהים ייחודיים."
    },
    "mailup-common-menu-organizer": {
        "text": "טקסט"
    },
    "mailup-bee-common-widgets-row-display-reverse-stack": {
        "label": "הפוך סדר מבנים במובייל"
    },
    "mailup-bee-newsletter-modules-carousel": {
        "name": "קרוסלה"
    },
    "mailup-bee-common-widgets-carousel": {
        "dot-navigation": "ניווט נקודות",
        "autoplay-interval": "מרווח הפעלה אוטומטית",
        "slide-delete": "שקופית נמחקה",
        "slide-update": "שקופית עודכנה",
        "slide-insert": "שקופית הוכנסה",
        "slide-dragged": "שקופית נגררה",
        "slide-replace": "שקופית החולפה",
        "resize": "שנה גודל קרוסלה",
        "dot-navigation-color": "צבע ניווט נקודות",
        "slide-order-change": "שנה סדר שקופיות",
        "dot-navigation-color-change": "צבע ניווט נקודות השתנה",
        "slide-input-update": "שקופיות עודכנות",
        "autoplay-interval-change": "מרווח הפעלה אוטומטית השתנה"
    },
    "mailup-bee-common-widgets-itemsspacing": {
        "label": "ריווח אייקונים"
    },
    "mailup-bee-commenting": {
        "edit": "ערוך",
        "delete": "מחק",
        "save": "שמור",
        "cancel": "ביטול",
        "submit": "שלח",
        "reply": "השב",
        "allCommentsTitle": "כל ההערות",
        "solvedFilterLabel": "נפתר",
        "emptyCommentsPlaceholderMessage": "הוסף הערה כללית חדשה",
        "newCommentPlaceholderMessage": "הוסף הערה חדשה",
        "actionResolve": "פתור מחדש",
        "actionReopen": "פתח מחדש",
        "labelResolved": "נפתר",
        "collapsibleShowMoreLabel": "הצג יותר",
        "collapsibleShowLessLabel": "הצג פחות",
        "addCommentFormPlaceholder": "הוסף הערה",
        "showRepliesLabel": "הצג את כל {repliesCount} התשובות",
        "backToAllCommentsButtonLabel": "חזרה לכל ההערות",
        "resolveCommentContent": "סומן כפתור",
        "reopenCommentContent": "נפתח מחדש",
        "deletedFilterLabel": "תוכן שנמחק",
        "labelDeletedModule": "התוכן נמחק"
    },
    "mailup-bee-common-widgets-iconpadding": {
        "label": "ריווח אייקונים"
    },
    "mailup-bee-carousel": {
        "configure-carousel": "הגדר קרוסלה",
        "first-slide-sizing-rule": "התמונה הממוקמת ראשונה תקבע את פרופורציות הקרוסלה. התמונות הבאות יתאימו את היחס שלהן לקרוסלה.",
        "autoplay": "הפעלה אוטומטית",
        "interval": "מרווח",
        "navigation": "ניווט",
        "color": "צבע"
    },
    "mailup-bee-common-widgets-message-align": {
        "label": "יישור אזור תוכן"
    },
    "mailup-bee-common-widgets-body-align": {
        "label": "יישר אזור תוכן",
        "left": "שמאל",
        "center": "מרכז",
        "right": "ימין"
    },
    "mailup-bee-common-widgets-heading": {
        "update": "כותרת עודכנה",
        "text-update": "טקסט כותרת עודכן",
        "default-text": "בלוק כותרת חדש",
        "title": "כותרת",
        "paragraph": "כיוון טקסט"
    },
    "mailup-bee-newsletter-modules-heading": {
        "name": "כותרת"
    },
    "mailup-bee-common-widgets-attributes": {
        "label": "תכונות",
        "dropdown-label": "הוסף תכונה חדשה",
        "target-link": "קישור",
        "target-tag": "תגית"
    },
    "mailup-bee-common-widgets-letter-spacing": {
        "label": "ריווח אותיות"
    }
}
//#endregion